// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutocompleteResults__autoCompleteItems___SaKij {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #e4e4e4;
  border-radius: 0 0 3px 3px;
  background-color: #fff;
}

.AutocompleteResults__autoCompleteItems___SaKij ul {
    list-style: none;
    padding: 0;
  }

.AutocompleteResults__autoCompleteItems___SaKij ul:last-child li:last-child {
        border: 0;
      }

.AutocompleteResults__autoCompleteItems___SaKij li {
    cursor: pointer;
    padding: 16px;
    padding-top: 10px;
    height: auto;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: 1px solid rgba(195, 195, 195, 0.45);
    display: flex;
    align-items: center;
    gap: 4px;
  }

.AutocompleteResults__autoCompleteItems___SaKij li:hover {
      background-color: rgba(55, 110, 161, 0.1) !important;
    }

.AutocompleteResults__autoCompleteItems___SaKij .AutocompleteResults__active___X8NBu {
    background-color: rgba(55, 110, 161, 0.1);
  }

.AutocompleteResults__autoCompleteItems___SaKij .AutocompleteResults__user_icon___jixnv {
    fill: #5faba1;
  }

_sectionTitle.AutocompleteResults__autoCompleteItems___SaKij {
    display: block;
  }

_icon.AutocompleteResults__autoCompleteItems___SaKij {
    margin-right: 20px;
  }

.AutocompleteResults__autoCompleteItems_label___BP1dT {
  display: flex;
  flex-direction: column;
}

.AutocompleteResults__user_icon___jixnv {
  fill: #5faba1;
  color: #5faba1;
}

.AutocompleteResults__top_line___k3ORw {
  font-weight: bold;
  margin-bottom: 0;
}

.AutocompleteResults__accountPrimary___amzdx {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.AutocompleteResults__statusBadge___pYi1q {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
}

.AutocompleteResults__statusBadge___pYi1q::before {
  content: '';
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.AutocompleteResults__statusActive___ZXFd4 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.AutocompleteResults__statusActive___ZXFd4::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.AutocompleteResults__statusClosed___ab2SG {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.AutocompleteResults__statusClosed___ab2SG::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.AutocompleteResults__statusClosing___cPWOF,
.AutocompleteResults__statusSuspended___RdmIa
 .AutocompleteResults__statusPending___gqlHA {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
}

.AutocompleteResults__statusClosing___cPWOF::before,
.AutocompleteResults__statusSuspended___RdmIa::before,
.AutocompleteResults__statusPending___gqlHA::before {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
}

.AutocompleteResults__statusDefault___pxmKj {
  color: #5f5f5f;
}

.AutocompleteResults__statusDefault___pxmKj::before {
  background: #8a8a8a;
}

.AutocompleteResults__small___OgYtw {
  font-size: 12px;
}

.AutocompleteResults__matchedText___sFvA_ {
  font-weight: 200;
  display: inline !important;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Autocomplete/AutocompleteResults.css"],"names":[],"mappings":"AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AA6CxB;;AA3CE;IACE,gBAAgB;IAChB,UAAU;EAOZ;;AAJI;QACE,SAAS;MACX;;AAIJ;IACE,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,QAAQ;EAKV;;AAHE;MACE,oDAAoD;IACtD;;AAGF;IACE,yCAAyC;EAC3C;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,cAAc;EAChB;;AAEA;IACE,kBAAkB;EACpB;;AAGF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mDAAc;AAChB;;AAEA;EACE,wDAAmB;AACrB;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,wDAAiB;AACnB;;AAEA;;;EAGE,mDAAmB;AACrB;;AAEA;;;EAGE,wDAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":["@value colors: 'styles/colors.css';\n@value gtRed, gtGreen, gtYellowDark from colors;\n\n.autoCompleteItems {\n  padding-top: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border: 1px solid #e4e4e4;\n  border-radius: 0 0 3px 3px;\n  background-color: #fff;\n\n  ul {\n    list-style: none;\n    padding: 0;\n\n    &:last-child {\n      li:last-child {\n        border: 0;\n      }\n    }\n  }\n\n  li {\n    cursor: pointer;\n    padding: 16px;\n    padding-top: 10px;\n    height: auto;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-bottom: 1px solid rgba(195, 195, 195, 0.45);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    &:hover {\n      background-color: rgba(55, 110, 161, 0.1) !important;\n    }\n  }\n\n  .active {\n    background-color: rgba(55, 110, 161, 0.1);\n  }\n\n  .user_icon {\n    fill: #5faba1;\n  }\n\n  &_sectionTitle {\n    display: block;\n  }\n\n  &_icon {\n    margin-right: 20px;\n  }\n}\n\n.autoCompleteItems_label {\n  display: flex;\n  flex-direction: column;\n}\n\n.user_icon {\n  fill: #5faba1;\n  color: #5faba1;\n}\n\n.top_line {\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.accountPrimary {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.statusBadge {\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n}\n\n.statusBadge::before {\n  content: '';\n  display: inline-block;\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  margin-right: 4px;\n}\n\n.statusActive {\n  color: gtGreen;\n}\n\n.statusActive::before {\n  background: gtGreen;\n}\n\n.statusClosed {\n  color: gtRed;\n}\n\n.statusClosed::before {\n  background: gtRed;\n}\n\n.statusClosing,\n.statusSuspended\n .statusPending {\n  color: gtYellowDark;\n}\n\n.statusClosing::before,\n.statusSuspended::before,\n.statusPending::before {\n  background: gtYellowDark;\n}\n\n.statusDefault {\n  color: #5f5f5f;\n}\n\n.statusDefault::before {\n  background: #8a8a8a;\n}\n\n.small {\n  font-size: 12px;\n}\n\n.matchedText {\n  font-weight: 200;\n  display: inline !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `'styles/colors.css'`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"autoCompleteItems": `AutocompleteResults__autoCompleteItems___SaKij`,
	"active": `AutocompleteResults__active___X8NBu`,
	"user_icon": `AutocompleteResults__user_icon___jixnv`,
	"autoCompleteItems_label": `AutocompleteResults__autoCompleteItems_label___BP1dT`,
	"top_line": `AutocompleteResults__top_line___k3ORw`,
	"accountPrimary": `AutocompleteResults__accountPrimary___amzdx`,
	"statusBadge": `AutocompleteResults__statusBadge___pYi1q`,
	"statusActive": `AutocompleteResults__statusActive___ZXFd4`,
	"statusClosed": `AutocompleteResults__statusClosed___ab2SG`,
	"statusClosing": `AutocompleteResults__statusClosing___cPWOF`,
	"statusSuspended": `AutocompleteResults__statusSuspended___RdmIa`,
	"statusPending": `AutocompleteResults__statusPending___gqlHA`,
	"statusDefault": `AutocompleteResults__statusDefault___pxmKj`,
	"small": `AutocompleteResults__small___OgYtw`,
	"matchedText": `AutocompleteResults__matchedText___sFvA_`
};
export default ___CSS_LOADER_EXPORT___;
